import { Type } from 'lucide-react';
import { SUBTITLE_FONTS, isValidFontFamily } from '@/lib/constants';
import type { SubtitleStyle, SubtitleFontFamily } from '@/types';

interface FontSettingsProps {
  style: SubtitleStyle;
  onUpdate: (updates: Partial<SubtitleStyle>) => void;
}

export function FontSettings({ style, onUpdate }: FontSettingsProps) {
  return (
    <section>
      <div className="settings-section-header">
        <div className="settings-icon-box settings-icon-box-coral">
          <Type size={14} className="text-coral-600" />
        </div>
        <h3 className="settings-section-title">フォント設定</h3>
      </div>
      <div className="space-y-3 pl-9">
        <div>
          <label className="settings-label-block">フォント</label>
          <select
            value={style.fontFamily}
            onChange={(e) => {
              if (isValidFontFamily(e.target.value)) {
                onUpdate({ fontFamily: e.target.value as SubtitleFontFamily });
              }
            }}
            className="select-base text-sm"
          >
            {SUBTITLE_FONTS.map((font) => (
              <option key={font.id} value={font.id}>
                {font.displayName}（{font.name}）
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="settings-label-block">
            サイズ <span className="text-coral-600">{style.fontSize}px</span>
          </label>
          <input
            type="range"
            min="16"
            max="96"
            step="2"
            value={style.fontSize}
            onChange={(e) => onUpdate({ fontSize: parseInt(e.target.value) })}
            className="range-slider range-slider-full"
          />
        </div>

        <div className="flex items-center justify-between">
          <span className="settings-label">太字</span>
          <button
            type="button"
            role="switch"
            aria-checked={style.fontWeight === 'bold'}
            aria-label="太字の切り替え"
            onClick={() => onUpdate({
              fontWeight: style.fontWeight === 'bold' ? 'normal' : 'bold'
            })}
            className={`toggle-switch ${style.fontWeight === 'bold' ? 'toggle-switch-on' : 'toggle-switch-off'}`}
          >
            <span className={`toggle-knob ${style.fontWeight === 'bold' ? 'toggle-knob-on' : ''}`} />
          </button>
        </div>
      </div>
    </section>
  );
}
